import type { Capability } from "owa-capabilities";
import type { MailboxInfo } from "owa-client-types";
import { isOfflineSyncEnabled } from "owa-offline-sync-feature-flags";
import { getIsOfflineDataFaulted } from "owa-config";
import { getApplicationSettings } from "owa-application-settings";

/**
 * NOTE: Please see the README for more information on how the
 * capability functions must be implemented and used.
 *
 * This capability is being used to check in which platforms the custom notification sound feature is enabled
 */
export const customNotificationSoundCapability: Capability = {
    isEnabled: (_mailboxInfo?: MailboxInfo) => {
        return true; // This capability is enabled by default
    },
    isSupported: (_mailboxInfo?: MailboxInfo) => {
        return (getApplicationSettings("MonarchNotifications").enabled &&
            isOfflineSyncEnabled() &&
            !getIsOfflineDataFaulted());
    },
};
